import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../universities";

export const FETCH_DELETE_UNIVERSITIES_REQUEST = 'FETCH_DELETE_UNIVERSITIES_REQUEST';
export const FETCH_DELETE_UNIVERSITIES_SUCCESS = 'FETCH_DELETE_UNIVERSITIES_SUCCESS';
export const FETCH_DELETE_UNIVERSITIES_FAILURE = 'FETCH_DELETE_UNIVERSITIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteUniversitiesRequest = () => {
    return {
        type: FETCH_DELETE_UNIVERSITIES_REQUEST,
    };
};

const fetchDeleteUniversitiesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_UNIVERSITIES_SUCCESS,
        payload: data
    };
};

const fetchDeleteUniversitiesFailure = (error: any) => {
    return {
        type: FETCH_DELETE_UNIVERSITIES_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteUniversitiesRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteUniversitiesSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteUniversitiesFailure(error.message));
        }
    };
};
